<template>
  <div>
    <b-tabs pills card vertical>
      <b-tab :title="category.title" v-for="(category,index) in negativeMedia" :key="index">
        <b-row>
          <!-- google search component  -->
          <b-col
            v-if="category.results && category.results.length"
            cols="12"
            style="height:calc(100vh - 250px); overflow-y: scroll"
          >
          <b-tabs>
            <b-tab title="Unfiltered">
                <h4>Google({{(category.results.length || 0)}})</h4>

            <SearchResult
              v-for="(item, index) in category.results"
              :key="index"
              :resultData="item"
              :resultIndex="index"
              :keywords="category.searchKeywords"
            ></SearchResult>
            </b-tab>
            <!-- <b-tab title="Filtered Results">
              <h4>Google Filtered results ({{(category.filteredResults.length || 0)}})</h4>
              <SearchResult
              v-for="(item, index) in category.filteredResults"
              :key="index"
              :resultData="item"
              :resultIndex="index"
              :keywords="category.searchKeywords"
              :filtered="true"
            ></SearchResult>
            </b-tab> -->
          </b-tabs>
            
          </b-col>
         
          
        </b-row>
        <p
          class="text-center my-5"
          v-if="!negativeMedia.length"
        >No Result Found</p>
      </b-tab>
    </b-tabs>
  </div>
</template>
<script>
import SearchResult from "../../negative-media/search-results.vue";

export default {
  name: "MediaResultsDataComponent",
  components: {
    SearchResult
  },
  data() {
    return {
      
    };
  },
  mounted() {
    
  },
  computed: {},
  methods: {},
  props: {
    
    negativeMedia: Array,
    
  }
};
</script>